export const KINDS_SET = "KINDS_SET";
export const ROOMS_SET = "ROOMS_SET";
export const AREAS_SET = "AREAS_SET";
export const RENTS_SET = "RENTS_SET";
export const DEPOSITS_SET = "DEPOSITS_SET";

export const PLACES_SET = "PLACES_SET";

export const SLIDE_TOGGLE = "SLIDE_TOGGLE";

export const TOUR_TOGGLE = "TOUR_TOGGLE";
export const TOUR_SET = "TOUR_SET";

export const PAGE_TOGGLE = "PAGE_TOGGLE";
export const PAGE_SET = "PAGE_SET";
